import { useMemo } from 'react';
import { useGetStatus } from '~/api/hooks/useGetStatus';
import { useRegion } from '~/features/region/hooks/useRegion';
import { userGetters } from '~/recoil/user';
import { nowDate } from '~/utils/time';

export const useStatusByDate = (date: string | undefined) => {
  const user = userGetters.useValue();
  const { regionCode } = useRegion();

  const params = useMemo(
    () =>
      date && user?.selected_child_id
        ? { date, child_id: user.selected_child_id, regionCode }
        : null,
    [date, user?.selected_child_id, regionCode],
  );

  return useGetStatus(params);
};

export const useCurrentStatus = () => useStatusByDate(nowDate());
